import { Alert, Dialog, Skeleton, Stack } from '@all-manager/design-system-v2';
import { Controller } from "react-hook-form";
import ContactNameAutocomplete from "../../../../../components/ContactNameAutocomplete/ContactNameAutocomplete";
import DateField from "../../../../../components/modals/components/DateFieldOk";
import DescriptionFieldOk from "../../../../../components/modals/components/DescriptionFieldOk";
import ProviderAutocomplete from "../../../../../components/ProviderAutocomplete/ProviderAutocomplete";
import type { SubjectHistoryFeed } from "../../../../../types";
import DocumentsFormSection from "../../../../documents/external-components/DocumentsFormSection/DocumentsFormSection";
import useAddReminderActionModal from "./useAddReminderActionModal";

type Props = {
  onClose: () => void;
  subjectId: string;
  item?: SubjectHistoryFeed;
}

export default function AddReminderActionModal(props: Props) {
  const { form, handleConfirm, isLoading, serverError, isDocumentLoading } = useAddReminderActionModal(props);

  return (
    <Dialog
      open
      onClose={props.onClose}
      maxWidth="sm"
      fullWidth
      title={props.item ? "Modifier la relance" : "Nouvelle relance"}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Enregistrer',
          onClick: form.handleSubmit(handleConfirm),
          loading: isLoading,
          disabled: isDocumentLoading,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: props.onClose,
          disabled: isLoading,
        },
      }}
    >
      <Stack spacing={2}>
        {serverError ? <Alert severity="error">{serverError}</Alert> : null}

        <DateField
          name="date"
          form={form}
          label="Date"
          isTimeManaged={false}
          required
        />

        <Controller
          control={form.control}
          name='provider_name'
          render={({ field, fieldState }) => (
            <ProviderAutocomplete
              label="Destinataire"
              value={field.value ?? ''}
              onChange={field.onChange}
              fullWidth
              required
              autoFocus
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />

        <Controller
          control={form.control}
          name='contact_name'
          render={({ field, fieldState }) => (
            <ContactNameAutocomplete
              label="Contacté par"
              value={field.value ?? ''}
              onChange={field.onChange}
              fullWidth
              required
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />

        <DescriptionFieldOk
          form={form}
          name="comment"
          label="Commentaire"
        />

        {isDocumentLoading ? (
          <Skeleton variant="rounded" height={120} aria-label="Chargement des documents" />
        ) : (
          <Controller
            name='documents'
            control={form.control}
            render={({ field }) => (
              <DocumentsFormSection
                documents={field.value}
                onChange={field.onChange}
                subjectId={props.subjectId}
              />
            )}
          />
        )}
      </Stack>
    </Dialog>
  );
}
